import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Prismic from 'prismic-javascript';

const Container = styled.div`
  padding: 35px 0 25px;
  .wrapper {
    justify-content: space-between;
    align-items: flex-start;

    a {
      text-decoration: none;
    }
    div {
      width: 25%;
    }
    @media (max-width: 1024px) {
      .contact-column {
        display: none;
      }
      .contact {
        display: block;
        width: 100%;
        margin-bottom: 60px;
      }
    }
  }
  .contact,
  .contact-column {
    display: none;
  }
  @media (max-width: 789px) {
    display: none;
  }
  @media (max-width: 789px) {
    display: none;
  }
  @media (min-width: 1024px) {
    .contact-column {
      display: block;
    }
  }
`
const Title = styled.span`
  color: #D2AE82;
  font: italic bold 22px 'Times New Roman';
  display: block;
  margin-bottom: 24px;
  transition: all 0.3s;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: #fff;
  }
`
const List = styled.ul`
  margin: 18px 0 0;
  padding: 0;
  li {
    margin-bottom: 18px;
    display: block;
    span,
    a {
      color: #808080;
      text-decoration: none;
      font-size: 14px;
      font-weight: 600;
      transition: all 0.3s;
      &:hover {
        color: #fff;
      }
      &.regular {
        font-weight: normal;
      }
    }
  }
`
const SubList = styled.ul`
  margin: 8px 0 0 20px;
  padding: 0;
  li {
    margin-bottom: 10px;
    display: block;
  }
`

class MenuEnUs extends Component {
  state = {
    mdf: [],
    compensados: [],
  }
  
  componentDidMount = () => {
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);
    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'tipo_de_produtos'),
        {lang: 'en-us'}
      )
      if (response) {
        const mdf = [];
        const compensados = [];
        response.results.map((item, index) => {
          switch (item.data.tipo) {
            case 'MDF':
              mdf.push(item);
              break;
            case 'Compensados':
              compensados.push(item);
              break;
            default:
          }
          return true;
        })
        this.setState({'mdf': mdf, 'compensados': compensados});
      }
    }
    fetchData();
  }

  render () {
    return (
    <Container>
      <div className="wrapper flex">
        <div>
          <Link to="/a-guararapes">
            <Title>About us</Title>
          </Link>
          <List>
            <li>
              <Link to="/a-guararapes/Historia">History</Link>
            </li>
            <li>
              <Link to="/a-guararapes/manifesto">Manifesto</Link>
            </li>
            <li>
              <Link to="/a-guararapes/sobre">About us</Link>
            </li>
            <li>
              <Link to="/a-guararapes/responsabilidade-ambiental-socials">Responsabilities</Link>
            </li>
            <li>
              <Link to="/a-guararapes/unidades">Our units</Link>
            </li>
          </List>
          </div>
          <div>
            <Link to="/produtos">
              <Title>Produtos</Title>
            </Link>
            <List>
              <li>
                <Link to="/produtos/mdf">
                  <span>MDF</span>
                </Link>
                <SubList>
                  {
                    this.state.mdf.map((item, index) => {
                      return (
                        <li key={ index }>
                          <Link to={ `/produtos/${item.uid}` }>{ item.data.nome[0].text }</Link>
                        </li>    
                      )
                    })
                  }
                  <li>
                    <Link to="/certificados/mdf">Certifications</Link>
                  </li>  
                </SubList>
              </li>
              <li>
                <Link to="/produtos/compensados">
                  <span>Plywood</span>
                </Link>
                <SubList>
                  {
                    this.state.compensados.map((item, index) => {
                      return (
                        <li key={ index }>
                          <Link to={ `/produtos/${item.uid}` }>{ item.data.nome[0].text }</Link>
                        </li>    
                      )
                    })
                  }
                  <li>
                    <Link to="/certificados/compensados">Certifications</Link>
                  </li>    
                </SubList>
              </li>
            </List>
          </div>
          <div>
            <Link to="/conteudos">
              <Title>Content</Title>
            </Link>
            <List>
              <li>
                <Link to="/conteudos/conteudos">Blog</Link>
              </li>
              <li>
                <Link to="/conteudos/videos">Videos</Link>
              </li>
              <li>
                <Link to="/conteudos/aprenda-mais">Learn more</Link>
              </li>
            </List>
          </div>
          <div className="contact-column">
            <Link to="/contato">
              <Title>Contact</Title>
            </Link>
            <List>
              <li>
                <Link to="/contato">FAQ</Link>
              </li>
              <li>
                <a href="https://etica.guararapes.com.br" rel="noopener noreferrer" target="_blank">Ethics Committee</a>
              </li>
            </List>
          </div>
          <div>
            <div className="contact">
              <Title to="/contato">Contact</Title>
              <List>
                <li>
                  <Link to="/contato">FAQ</Link>
                </li>
                <li>
                  <a href="https://etica.guararapes.com.br" rel="noopener noreferrer" target="_blank">Ethics Committee</a>
                </li>
              </List>
            </div>
            <Link to="/onde-encontrar/compensados">
              <Title>Where to find</Title>
            </Link>
          </div>
        </div>
      </Container>
    )
  }
}

MenuEnUs.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default MenuEnUs;
